import React from "react";
import "./loader.css";

/**
 * Usos:
 *   <Loader />                          → pantalla completa, ring animado, texto "Cargando…"
 *   <Loader message="Cargando datos" /> → cambia el texto
 *
 * Props opcionales:
 * - message?: string       → Texto principal (default "Cargando…")
 * - submessage?: string    → Texto secundario
 * - fullscreen?: boolean   → Overlay pantalla completa (default true)
 * - progress?: number      → 0..1 (si lo pasas, el ring y el punto siguen el progreso)
 * - showBackdrop?: boolean → Fondo difuminado (default true)
 */
const Loader = ({
  message = "Cargando…",
  submessage,
  fullscreen = true,
  progress,
  showBackdrop = true,
}) => {
  const pct =
    typeof progress === "number" ? Math.max(0, Math.min(1, progress)) : null;

  // Variables CSS: porcentaje del ring y ángulo del punto (sincronizado con progress)
  const styleVars =
    pct != null
      ? {
          "--ld-p": `${pct * 100}%`,
          "--ld-angle-deg": `${pct * 360}deg`,
        }
      : undefined;

  return (
    <div
      className={`ld ${fullscreen ? "ld--full" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={styleVars}
    >
      {showBackdrop && <div className="ld__backdrop" aria-hidden="true" />}

      <div className="ld__card">
        <div className="ld__visual" aria-hidden="true">
          <div className="ld__ring">
            <span className="ld__ringTrack" />
            <span className={`ld__ringProg ${pct == null ? "is-anim" : ""}`} />

            {/* NUEVO: órbita estable (rota el wrapper, no el punto) */}
            <span className={`ld__dotWrap ${pct == null ? "is-anim" : ""}`}>
              <span className="ld__dot" />
            </span>

            <span className="ld__ticks" />
          </div>
        </div>

        <div className="ld__text">
          <div className="ld__title">{message}</div>
          {submessage && <div className="ld__sub">{submessage}</div>}
          {pct != null && (
            <div className="ld__pct">{Math.round(pct * 100)}%</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Loader;